import { Button, Result } from 'antd'
import { FC, ReactNode, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { RNWelcome } from '../helpers/routeNames'
import { useTelegram } from '../store/telegram'
import { authStore } from '../store/auth'

const RegisterRequest: FC = () => {
	const { search } = useLocation()
	const { t } = useTranslation()
	const { tg } = useTelegram()
	const { user } = authStore()
	const navigate = useNavigate()

	const query = useMemo(() => new URLSearchParams(search), [search])

	useEffect(() => {
		if (user?.role) {
			if (
				!query.has('result') ||
				!['EXECUTIVE', 'ADMIN'].includes(user?.role)
			) {
				navigate(RNWelcome)
			}
		}
	}, [navigate, query, user])

	const results = {
		ALLOWED: {
			status: 'success' as any,
			title: 'RegisterRequest',
			subTitle: 'RegisterRequestData',
			btns: [],
			children: []
		},
		REJECTED: {
			status: 'error',
			title: 'RegisterFail',
			subTitle: 'RegisterFailData',
			children: [],
			btns: [
				// {
				// 	type: 'default',
				// 	text: 'GoAhead',
				// 	nextUrl: RNWelcome
				// },
				// {
				// 	type: 'primary',
				// 	text: 'GoAhead',
				// 	nextUrl: RNWelcome
				// }
			]
		}
	}

	const result =
		results[query.get('result') as 'ALLOWED' | 'REJECTED'] ||
		results.ALLOWED

	return (
		<Result
			status={result.status}
			title={<h1 style={{ margin: 0 }}>{t(result.title)}</h1>}
			subTitle={
				<h2 style={{ margin: 0 }}>{t(result.subTitle)}</h2>
			}
			children={
				[].length ? (
					<>
						{[].map((child: ReactNode, i: number) => (
							<p key={i} style={{ margin: 0 }}>
								{child}
							</p>
						))}
					</>
				) : null
			}
			extra={[
				result.btns.length
					? result.btns.map((btn: any, i) => (
							<Button
								key={i}
								type={btn.type}
								onClick={() => navigate(btn.nextUrl)}>
								{t(btn.text)}
							</Button>
						))
					: null,
				<Button type="primary" onClick={() => tg.close()}>
					{t('Home')}
				</Button>
			]}
		/>
	)
}

export default RegisterRequest
